module.exports = __webpack_public_path__ + "static/media/10.microsoft-powerpoint.3691d95e.svg";